module.exports = __webpack_public_path__ + "img/storeTag.06e98d23.svg";